// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/offboarding/v1/offboarding.proto" (package "c1.api.offboarding.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingSearchRequest
 */
export interface OffboardingSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string offboarding_ticket_ids = 2;
     */
    offboardingTicketIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 3;
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 4;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string app_entitlement_ids = 5;
     */
    appEntitlementIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerOutcome outcomes = 6;
     */
    outcomes: OffboardingTrackerOutcome[];
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask = 7;
     */
    expandMask?: OffboardingTrackerExpandMask;
    /**
     * @generated from protobuf field: int32 page_size = 8;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 9;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerRef refs = 10;
     */
    refs: OffboardingTrackerRef[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingSearchResponse
 */
export interface OffboardingSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerView list = 1;
     */
    list: OffboardingTrackerView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerRequest
 */
export interface MutateOffboardingTrackerRequest {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1;
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome outcome = 5;
     */
    outcome?: OffboardingTrackerOutcome;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerResponse
 */
export interface MutateOffboardingTrackerResponse {
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1;
     */
    offboardingTracker?: OffboardingTracker;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.GetOffboardingTrackerResponse
 */
export interface GetOffboardingTrackerResponse {
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1;
     */
    offboardingTracker?: OffboardingTracker;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.GetOffboardingTrackerRequest
 */
export interface GetOffboardingTrackerRequest {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1;
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.ListOffboardingTrackersRequest
 */
export interface ListOffboardingTrackersRequest {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1;
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask = 4;
     */
    expandMask?: OffboardingTrackerExpandMask;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.ListOffboardingTrackersResponse
 */
export interface ListOffboardingTrackersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerView list = 1;
     */
    list: OffboardingTrackerView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTracker
 */
export interface OffboardingTracker {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1;
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome outcome = 7;
     */
    outcome?: OffboardingTrackerOutcome;
    /**
     * @generated from protobuf field: string app_entitlement_id = 8;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string tenant_id = 9;
     */
    tenantId: string;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerExpandMask
 */
export interface OffboardingTrackerExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerView
 */
export interface OffboardingTrackerView {
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1;
     */
    offboardingTracker?: OffboardingTracker;
    /**
     * @generated from protobuf field: string offboarding_ticket_id_path = 2;
     */
    offboardingTicketIdPath: string;
    /**
     * @generated from protobuf field: string app_id_path = 3;
     */
    appIdPath: string;
    /**
     * @generated from protobuf field: string app_user_id_path = 4;
     */
    appUserIdPath: string;
    /**
     * @generated from protobuf field: string actor_id_path = 5;
     */
    actorIdPath: string;
    /**
     * @generated from protobuf field: string outcome_path = 6;
     */
    outcomePath: string;
    /**
     * @generated from protobuf field: string app_entitlement_id_path = 7;
     */
    appEntitlementIdPath: string;
}
/**
 * Putting this in it's own message makes swith statements a lot easier
 *
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome
 */
export interface OffboardingTrackerOutcome {
    /**
     * @generated from protobuf field: string actor_id = 1;
     */
    actorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 2;
     */
    outcomeTime?: Timestamp;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "revoke";
        /**
         * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke revoke = 101;
         */
        revoke: OffboardingTrackerOutcome_Revoke;
    } | {
        oneofKind: "ignore";
        /**
         * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore ignore = 201;
         */
        ignore: OffboardingTrackerOutcome_Ignore;
    } | {
        oneofKind: "relatedObjectDeleted";
        /**
         * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted related_object_deleted = 301;
         */
        relatedObjectDeleted: OffboardingTrackerOutcome_RelatedObjectDeleted;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke
 */
export interface OffboardingTrackerOutcome_Revoke {
    /**
     * @generated from protobuf field: string ticket_id = 1;
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore
 */
export interface OffboardingTrackerOutcome_Ignore {
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted
 */
export interface OffboardingTrackerOutcome_RelatedObjectDeleted {
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerRef
 */
export interface OffboardingTrackerRef {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1;
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4;
     */
    appUserId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingSearchRequest$Type extends MessageType<OffboardingSearchRequest> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "offboarding_ticket_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "outcomes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerOutcome },
            { no: 7, name: "expand_mask", kind: "message", T: () => OffboardingTrackerExpandMask },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 9, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 10, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingSearchRequest
 */
export const OffboardingSearchRequest = new OffboardingSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingSearchResponse$Type extends MessageType<OffboardingSearchResponse> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingSearchResponse
 */
export const OffboardingSearchResponse = new OffboardingSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateOffboardingTrackerRequest$Type extends MessageType<MutateOffboardingTrackerRequest> {
    constructor() {
        super("c1.api.offboarding.v1.MutateOffboardingTrackerRequest", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "outcome", kind: "message", T: () => OffboardingTrackerOutcome }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerRequest
 */
export const MutateOffboardingTrackerRequest = new MutateOffboardingTrackerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateOffboardingTrackerResponse$Type extends MessageType<MutateOffboardingTrackerResponse> {
    constructor() {
        super("c1.api.offboarding.v1.MutateOffboardingTrackerResponse", [
            { no: 1, name: "offboarding_tracker", kind: "message", T: () => OffboardingTracker }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerResponse
 */
export const MutateOffboardingTrackerResponse = new MutateOffboardingTrackerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOffboardingTrackerResponse$Type extends MessageType<GetOffboardingTrackerResponse> {
    constructor() {
        super("c1.api.offboarding.v1.GetOffboardingTrackerResponse", [
            { no: 1, name: "offboarding_tracker", kind: "message", T: () => OffboardingTracker }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.GetOffboardingTrackerResponse
 */
export const GetOffboardingTrackerResponse = new GetOffboardingTrackerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOffboardingTrackerRequest$Type extends MessageType<GetOffboardingTrackerRequest> {
    constructor() {
        super("c1.api.offboarding.v1.GetOffboardingTrackerRequest", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.GetOffboardingTrackerRequest
 */
export const GetOffboardingTrackerRequest = new GetOffboardingTrackerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOffboardingTrackersRequest$Type extends MessageType<ListOffboardingTrackersRequest> {
    constructor() {
        super("c1.api.offboarding.v1.ListOffboardingTrackersRequest", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => OffboardingTrackerExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.ListOffboardingTrackersRequest
 */
export const ListOffboardingTrackersRequest = new ListOffboardingTrackersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOffboardingTrackersResponse$Type extends MessageType<ListOffboardingTrackersResponse> {
    constructor() {
        super("c1.api.offboarding.v1.ListOffboardingTrackersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.ListOffboardingTrackersResponse
 */
export const ListOffboardingTrackersResponse = new ListOffboardingTrackersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTracker$Type extends MessageType<OffboardingTracker> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTracker", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "outcome", kind: "message", T: () => OffboardingTrackerOutcome },
            { no: 8, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTracker
 */
export const OffboardingTracker = new OffboardingTracker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerExpandMask$Type extends MessageType<OffboardingTrackerExpandMask> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "offboarding_ticket_id", "app_id", "app_user_id", "actor_id", "outcome", "app_entitlement_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerExpandMask
 */
export const OffboardingTrackerExpandMask = new OffboardingTrackerExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerView$Type extends MessageType<OffboardingTrackerView> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerView", [
            { no: 1, name: "offboarding_tracker", kind: "message", T: () => OffboardingTracker },
            { no: 2, name: "offboarding_ticket_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "actor_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "outcome_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_entitlement_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerView
 */
export const OffboardingTrackerView = new OffboardingTrackerView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome$Type extends MessageType<OffboardingTrackerOutcome> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "outcome_time", kind: "message", T: () => Timestamp },
            { no: 101, name: "revoke", kind: "message", oneof: "outcome", T: () => OffboardingTrackerOutcome_Revoke },
            { no: 201, name: "ignore", kind: "message", oneof: "outcome", T: () => OffboardingTrackerOutcome_Ignore },
            { no: 301, name: "related_object_deleted", kind: "message", oneof: "outcome", T: () => OffboardingTrackerOutcome_RelatedObjectDeleted }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome
 */
export const OffboardingTrackerOutcome = new OffboardingTrackerOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome_Revoke$Type extends MessageType<OffboardingTrackerOutcome_Revoke> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke
 */
export const OffboardingTrackerOutcome_Revoke = new OffboardingTrackerOutcome_Revoke$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome_Ignore$Type extends MessageType<OffboardingTrackerOutcome_Ignore> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore
 */
export const OffboardingTrackerOutcome_Ignore = new OffboardingTrackerOutcome_Ignore$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome_RelatedObjectDeleted$Type extends MessageType<OffboardingTrackerOutcome_RelatedObjectDeleted> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted
 */
export const OffboardingTrackerOutcome_RelatedObjectDeleted = new OffboardingTrackerOutcome_RelatedObjectDeleted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerRef$Type extends MessageType<OffboardingTrackerRef> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerRef", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerRef
 */
export const OffboardingTrackerRef = new OffboardingTrackerRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.offboarding.v1.Offboarding
 */
export const Offboarding = new ServiceType("c1.api.offboarding.v1.Offboarding", [
    { name: "ListOffboardingTrackers", options: { "authz.method": { role: "VIEWER" } }, I: ListOffboardingTrackersRequest, O: ListOffboardingTrackersResponse },
    { name: "GetOffboardingTracker", options: { "authz.method": { role: "VIEWER" } }, I: GetOffboardingTrackerRequest, O: GetOffboardingTrackerResponse },
    { name: "MutateOffboardingTracker", options: { "authz.method": { role: "EDITOR" } }, I: MutateOffboardingTrackerRequest, O: MutateOffboardingTrackerResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.offboarding.v1.OffboardingSearchService
 */
export const OffboardingSearchService = new ServiceType("c1.api.offboarding.v1.OffboardingSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: OffboardingSearchRequest, O: OffboardingSearchResponse }
]);
